import React, { useEffect, useState } from "react";
import { Form, Input, Select, message, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../../css/freemium.css";
import { postEuaCalculateRequest } from "../../features/Voyage/VoyageSlice";
import { getPortNames } from "../../features/RawData/RawDataSlice";
import FuelEditModal from "./fuelModals/FuelDetailsModal";

const { Option } = Select;

const FreemiumPage = ({
  vesselData,
  fuelRows,
  biofuelMeta,
  selectedYear,
  isIceClass,
  iceClassData, 
  openFuelModal,
}) => {
  const dispatch = useDispatch();
  const { portSuggestions } = useSelector((state) => state.rawData);
  const [form] = Form.useForm();

  const [fromPortCode, setFromPortCode] = useState();
  const [fromPortName, setFromPortName] = useState();
  const [toPortCode, setToPortCode] = useState();
  const [toPortName, setToPortName] = useState();
  const [distance, setDistance] = useState();
  const [cargoWeight, setCargoWeight] = useState();
  const [voyageStartDate, setVoyageStartDate] = useState();
  const [voyageEndDate, setVoyageEndDate] = useState();

  const calculateFreemium = () => {
    if (!vesselData?.imoNumber || !fromPortCode || !toPortCode) {
      message.error("Please fill IMO Number, Port of Departure, and Port of Arrival");
      return;
    }

    const deadweightValue = Number(vesselData.deadweight || 0);
    if (deadweightValue === 0) {
      message.error("Deadweight cannot be zero. Please enter a valid deadweight value.");
      return;
    }

    // Only validate ice class data if ice class toggle is ON
    if (isIceClass) {
      if (!iceClassData.iceClassType) {
        message.error("Please configure Ice Class Type in the modal");
        return;
      }
      if ( iceClassData.iceDistance < 0) {
        message.error("Please enter Ice Class Distance in the modal",iceClassData.iceDistance);
        return;
      }
    }

    const fossilConsumption = fuelRows
      .filter(
        (f) =>
          f.fuel_class === "Fossil" &&
          f.fuel_name &&
          (Number(f.sea_consumption) > 0 ||
            Number(f.port_consumption) > 0 ||
            (isIceClass && Number(f.ice_class_consumption) > 0))
      )
     .map((f) => ({
  fuel_name: f.fuel_name,
  fuel_class: "fossil",

  sea_consumption: Number(f.sea_consumption || 0),

  port_consumption: Number(f.port_consumption || 0),

  uk_port_consumption: Number(f.uk_port_consumption || 0),

  ice_consumption: isIceClass
    ? Number(f.ice_class_consumption || 0)
    : 0,
}));

    /* ---------- BIOFUEL CONSUMPTION (ARRAY) ---------- */
    const biofuelConsumption = Array.isArray(biofuelMeta)
      ? biofuelMeta
          .filter(
            (b) =>
              b.biofuelName &&
              (Number(b.sea_consumption) > 0 ||
                Number(b.port_consumption) > 0 ||
                (isIceClass && Number(b.ice_class_consumption) > 0))
          )
         .map((b) => ({
  fuel_name: b.biofuelName,
  fuel_class: "Biofuel",

  sea_consumption: Number(b.sea_consumption || 0),

  port_consumption: Number(b.port_consumption || 0),

  uk_port_consumption: Number(b.uk_port_consumption || 0),

  ice_consumption: isIceClass
    ? Number(b.ice_class_consumption || 0)
    : 0,
}))
      : [];

    const consumption = [...fossilConsumption, ...biofuelConsumption];

    if (!consumption.length) {
      message.error("Enter fuel consumption values (fossil or biofuel)");
      return;
    }

    const biofuel_meta_info = Array.isArray(biofuelMeta)
      ? biofuelMeta.map((b) => ({
          biofuel_name: b.biofuelName,
          blend_percent: Number(b.blendRatio || 0),
          e_value: Number(b.eValue || 0),
          biofuel_type: b.fuelType,
          fossil_fuel_name: b.fossilFuelName,
          current_year: selectedYear,
        }))
      : [];

    const today = new Date().toISOString().split('T')[0];
    
    const reportKey = `report_${vesselData.imoNumber}_${voyageStartDate || today}_${voyageEndDate || today}`;
    let reportTimestamp = sessionStorage.getItem(reportKey);
    
    if (!reportTimestamp) {
      reportTimestamp = new Date().toISOString();
      sessionStorage.setItem(reportKey, reportTimestamp);
    }
    
    const cleanVesselName = (vesselData.vesselName || "VESSEL")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "_")
      .substring(0, 20);
    
    const date = new Date(reportTimestamp);
    const dateStr = date.toISOString().split("T")[0].replace(/-/g, "");
    const timeStr = date.toTimeString().split(" ")[0].replace(/:/g, "");
    
    const report_id = `${cleanVesselName}_${dateStr}_${timeStr}`;
    
const payload = {
  report_id,
  imo_number: vesselData.imoNumber,
  vessel_name: vesselData.vesselName || "",
  vessel_type: vesselData.vesselType || "",
  deadweight: deadweightValue,

  from_port_code: fromPortCode,
  from_port: fromPortName || "",
  to_port_code: toPortCode,
  to_port: toPortName || "",

  voyage_start_date: voyageStartDate || today,
  voyage_end_date: voyageEndDate || today,

  distance: Number(distance || 0),
  cargo_weight: Number(cargoWeight || 0),

  year: selectedYear,
  pprop: Number(vesselData.pProp || 100),
  pwind: Number(vesselData.pWind || 0),

  consumption,
  biofuel_meta_info,

  is_ice_class: isIceClass,

  ice_class_type: isIceClass ? iceClassData.iceClassType : null,

  ice_class_distance: isIceClass ? Number(iceClassData.iceDistance) : null,
};

    console.log("FINAL PAYLOAD:", payload);
    console.log("fuelRows going into payload:", fuelRows);


    dispatch(postEuaCalculateRequest(payload)).then((res) => {
      if (res?.error || !res?.payload) {
        message.error(res?.payload || "Failed to calculate EUA");
        return;
      }
      openFuelModal();
    });
  };

  useEffect(() => {
    document.addEventListener("CALCULATE_FREEMIUM", calculateFreemium);
    return () => {
      document.removeEventListener("CALCULATE_FREEMIUM", calculateFreemium);
    };
  }, [
    vesselData,
    fuelRows,
    biofuelMeta,
    selectedYear,
    isIceClass,
    iceClassData, 
    fromPortCode,
    toPortCode,
    voyageStartDate,
    voyageEndDate,
    distance,
    cargoWeight,
  ]);

  return (
    <div className="freemium-right-cards">
      <h3 className="card-title">Voyage Configuration</h3>

      <Form form={form} layout="vertical" className="freemium-form" size="large">
        <div className="freemium-grid freemium-grid--voyage-single">
          <Form.Item label="Port of Departure (UN/LOCODE)" required>
            <Select 
              showSearch
              onSearch={(v) => dispatch(getPortNames(v.toUpperCase()))}
              onChange={(v) => {
                setFromPortCode(v);
                const p = portSuggestions.find((x) => x.port_code === v);
                setFromPortName(p?.port_name);
              }}
            >
              {portSuggestions?.map((p) => (
                <Option key={p.port_code} value={p.port_code}>
                  {p.port_code}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Port of Arrival (UN/LOCODE)" required>
            <Select
              showSearch
              onSearch={(v) => dispatch(getPortNames(v.toUpperCase()))}
              onChange={(v) => {
                setToPortCode(v);
                const p = portSuggestions.find((x) => x.port_code === v);
                setToPortName(p?.port_name);
              }}
            >
              {portSuggestions?.map((p) => (
                <Option key={p.port_code} value={p.port_code}>
                  {p.port_code}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Distance (NM)">
            <Input onChange={(e) => setDistance(e.target.value)} placeholder="" />
          </Form.Item>

          <Form.Item label="Cargo Weight (MT)">
            <Input onChange={(e) => setCargoWeight(e.target.value)} placeholder="" />
          </Form.Item>

          <Form.Item label="From Date">
            <DatePicker
              style={{ width: "100%" }}
              placement="bottomLeft"
              getPopupContainer={() => document.body}
              onChange={(d) => setVoyageStartDate(d?.format("YYYY-MM-DD"))}
              disabledDate={(current) =>
                current && voyageEndDate && current > moment(voyageEndDate)
              }
              placeholder=""
            />
          </Form.Item>

          <Form.Item label="To Date">
            <DatePicker
              style={{ width: "100%" }}
              placement="bottomLeft"
              getPopupContainer={() => document.body}
              onChange={(d) => setVoyageEndDate(d?.format("YYYY-MM-DD"))}
              disabledDate={(current) =>
                current && voyageStartDate && current < moment(voyageStartDate)
              }
              placeholder=""
            />
          </Form.Item>
        </div>
      </Form>

      <FuelEditModal visible={false} />
    </div>
  );
};

export default FreemiumPage;
